import { fork, put, takeEvery } from 'redux-saga/effects';
import { AdminEventsApi } from 'api';
import { sagasHandlersFactory } from 'store/entities/utils';
import * as actions from './actions';

function* refetchAdminEventReminders(action: any): any {
  const eventId = action.payload?.params?.eventId;
  if (eventId !== undefined) {
    yield put(actions.getAdminEventReminders.request({ params: { eventId }, silent: true }));
  }
}

const handleGetAdminEventRemindersRequest = sagasHandlersFactory.createGetManyRequestHandler({
  actions: actions.getAdminEventReminders,
  request: AdminEventsApi.getAdminEventReminders,
  requestArgsBuilder: (action) => action.payload.params.eventId,
});

const handleRuntimeUpdateAdminEventReminder = sagasHandlersFactory.createRuntimeUpdateHandler({
  actions: actions.runtimeUpdateAdminEventReminder,
  request: AdminEventsApi.partialUpdateAdminEventReminder,
  requestArgsBuilder: (action) => {
    const { id, entity, params } = action.payload;
    const { eventId } = params;
    return [eventId, id, { body: entity }];
  },
});

const handleCreateAdminEventReminder = sagasHandlersFactory.createCreateOneRequestHandler({
  actions: actions.createAdminEventReminder,
  request: AdminEventsApi.postAdminEventReminders,
  requestArgsBuilder: (action) => {
    const { params, entity } = action.payload;
    const { eventId } = params;
    return [eventId, { body: entity }];
  },
  notifyError: false,
});

const handleDeleteAdminEventReminder = sagasHandlersFactory.createDeleteOneRequestHandler({
  actions: actions.deleteAdminEventReminder,
  request: AdminEventsApi.deleteAdminEventReminder,
  requestArgsBuilder: (action) => {
    const { id, params } = action.payload;
    const { eventId } = params;
    return [eventId, id];
  },
});

export default function* adminEventRemindersSagas() {
  yield takeEvery(actions.getAdminEventReminders.request.type, handleGetAdminEventRemindersRequest);
  yield fork(handleRuntimeUpdateAdminEventReminder);
  yield takeEvery(actions.createAdminEventReminder.request.type, handleCreateAdminEventReminder);
  yield takeEvery(actions.deleteAdminEventReminder.request.type, handleDeleteAdminEventReminder);
  yield takeEvery(actions.createAdminEventReminder.success.type, refetchAdminEventReminders);
  yield takeEvery(actions.runtimeUpdateAdminEventReminder.success.type, refetchAdminEventReminders);
}
